import React from "react";
import { Container, Stack, Typography, useMediaQuery } from "@mui/material";
import { LinkButton } from "components";
import Carousel from "react-material-ui-carousel/dist";

export const BusinessLeadersTips = () => {
  const desktopL = "(min-width: 1500px)";
  const matchesDesktop = useMediaQuery(desktopL);

  const config = [
    {
      title: "ROI: ką privalo žinoti kiekvienas verslas?",
      iframe: (
        <iframe
          height="250"
          src="https://www.youtube.com/embed/LbOS7c2e-Uk"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      ),
      link: "https://www.youtube.com/watch?v=LbOS7c2e-Uk&list=PLXcBo1oFe8xlpFFUAlH5DPMKMQIg74FxU&index=6&t=1s&ab_channel=SwedbankLietuvoje",
    },
    {
      title: "Finansų valdymo svarba verslui",
      iframe: (
        <iframe
          height="250"
          src="https://www.youtube.com/embed/bQTUWUSqeEw"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      ),
      link: "https://www.youtube.com/watch?v=bQTUWUSqeEw&list=PLXcBo1oFe8xlpFFUAlH5DPMKMQIg74FxU&index=28&ab_channel=SwedbankLietuvoje",
    },
    {
      title: "(Ne)lengvas kelias iki bankinio finansavimo",
      iframe: (
        <iframe
          height="256"
          src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2FKiekvienasGali%2Fvideos%2F779737346565046%2F"
          title="Facebook video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      ),
      link: "https://www.facebook.com/KiekvienasGali/videos/779737346565046",
    },
  ];

  return (
    <>
      <Typography variant="h3" color="primary" mb="3rem">
        Verslo lyderių patarimai
      </Typography>
      {matchesDesktop ? (
        <Stack direction="row" justifyContent="space-between">
          {config.map(({ title, link, iframe }) => (
            <Stack key={title} width="30%" spacing={2}>
              {iframe}
              <Typography variant="h4" mb="1rem">
                {title}
              </Typography>
              <LinkButton href={link} small>
                Žiūrėti video
              </LinkButton>
            </Stack>
          ))}
        </Stack>
      ) : (
        <Carousel
          indicators
          animation="slide"
          navButtonsAlwaysInvisible
          autoPlay={false}
          indicatorIconButtonProps={{
            style: {
              color: "#E4E4E4",
            },
          }}
          activeIndicatorIconButtonProps={{
            style: {
              color: "#FF5F00",
            },
          }}
        >
          {config.map(({ title, link, iframe }) => (
            <Container key={title} maxWidth="xs">
              <Stack spacing={1} m="auto">
                {iframe}
                <Typography variant="h4" mb="1rem">
                  {title}
                </Typography>
                <LinkButton href={link} small>
                  Žiūrėti video
                </LinkButton>
              </Stack>
            </Container>
          ))}
        </Carousel>
      )}
    </>
  );
};
